import React from 'react'
import V2Layout from '../../components/V2Layout'
import SEO from '../../components/SEO'
import CapabilityPageNav from './CapabilityPageNav'
import CapabilitySections from './CapabilitySections'
import useCompanyStats from '../../components/useCompanyStats'
import '../../versions/v2/capabilities.css'

const ContractManufacturingPage = () => {
    const { stats } = useCompanyStats()
    return (
        <V2Layout pageClass="pfc-capabilities">
            <SEO
                title="Manufacture, Assemble and Test Customer IP Components"
                description="Machine customer IP to print, assemble and test per customer specifications."
            />
            <section className="pfc-page-hero">
                <div className="pfc-page-hero-inner">
                    <p className="v2-section-label">Our Capabilities · 06</p>
                    <h1 className="pfc-page-hero-title">Manufacture, Assemble and Test Customer IP Components</h1>
                    <p className="pfc-page-hero-sub">
                        Precision Fluid Controls (PFC) provides end-to-end manufacturing, assembly and testing solutions designed to bring your proprietary designs to life. We specialize in machining highly complex geometries and challenging, high-strength materials strictly to your custom prints. By combining precision machining with class-certified cleanroom and controlled-environment assembly, we ensure your critical components are built to the highest standards of cleanliness and integrity.
                    </p>
                </div>
            </section>

            <section className="cap-section">
                <div className="cap-section-inner">
                    <div className="cap-grid-2">
                        <div>
                            <p className="cap-intro-text">
                                To guarantee performance in the most demanding environments, we subject every assembly to rigorous, customer-specified testing protocols. Whether your project requires proof, ambient, vibration, thermal or extreme cryogenic testing, PFC delivers fully validated, mission-ready components that protect your intellectual property at every stage of production.
                            </p>

                            <h4 className="cap-equip-label"></h4>
                            <div className="cap-feature-list">
                                <div className="cap-feature"><strong></strong><span>Machine difficult geometries and hard materials</span></div>
                                <div className="cap-feature"><strong></strong><span>Assemble components in a clean room or controlled environment</span></div>
                                <div className="cap-feature"><strong></strong><span>Test per customer specifications including proof, ambient, cryogenic, vibration or thermal requirements</span></div>

                            </div>

                            
                        </div>
                        <div className="cap-panel">
                            <h3 className="cap-panel-heading">Full-Service Offering</h3>
                            <div className="cap-spec-list">
                                <div className="cap-spec-row"><span>Lights-out machining</span><strong>Automated / 24-hr</strong></div>
                                <div className="cap-spec-row"><span>Materials</span><strong>Hard alloys, exotic metals</strong></div>
                                <div className="cap-spec-row"><span>Cleaning</span><strong>Precision, IEST-CC1246E</strong></div>
                                <div className="cap-spec-row"><span>Passivation</span><strong>Citric acid process</strong></div>
                                <div className="cap-spec-row"><span>Assembly</span><strong>Component &amp; sub-assembly</strong></div>
                                <div className="cap-spec-row"><span>Environmental test</span><strong>Vibration, thermal, etc.</strong></div>
                                <div className="cap-spec-row"><span>Acceptance test</span><strong>Piece-part level</strong></div>
                                <div className="cap-spec-row"><span>Proof test</span><strong>Piece-part level</strong></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <CapabilitySections slug="contract-manufacturing" />

            <CapabilityPageNav currentSlug="contract-manufacturing" />
        </V2Layout>
    )
}

export default ContractManufacturingPage
